import { restRequestTheme } from '../lib/rest-api';
import { createGenericModal } from '../components';
export function initCacheControls() {
    const adminBarRootEl = document.getElementById('wp-admin-bar-skp-cache');
    if (adminBarRootEl) {
        initAdminBar(adminBarRootEl);
    }
}
function initAdminBar(rootEl) {
    const flushAllEl = rootEl.querySelector('a[href="#flush-all"]');
    const flushCurrentEl = rootEl.querySelector('a[href="#flush-current"]');
    flushAllEl === null || flushAllEl === void 0 ? void 0 : flushAllEl.addEventListener('click', clickHandler(flushAllEl, async () => {
        var _a;
        const resp = await restRequestTheme('POST', 'cache/flush/all');
        return (_a = resp === null || resp === void 0 ? void 0 : resp.payload) === null || _a === void 0 ? void 0 : _a.message_html;
    }, '<h3>Are you sure you want to flush all caches?</h3><p>This will remove all cached pages and objects from the cache.</p>', '<p>Failed to flush all caches</p>'));
    flushCurrentEl === null || flushCurrentEl === void 0 ? void 0 : flushCurrentEl.addEventListener('click', clickHandler(flushCurrentEl, async () => {
        var _a, _b;
        const cacheKey = (_a = flushCurrentEl.nextSibling) === null || _a === void 0 ? void 0 : _a.getAttribute('value');
        const currentUrl = window.location.href.replace(/[?#].*$/, '');
        const resp = await restRequestTheme('POST', `cache/flush/${cacheKey}?url=${encodeURIComponent(currentUrl)}`);
        return (_b = resp === null || resp === void 0 ? void 0 : resp.payload) === null || _b === void 0 ? void 0 : _b.message_html;
    }, '', '<p>Failed to flush current page cache</p>'));
    function clickHandler(el, callback, confirmMsg, failureMsg) {
        return async (event) => {
            event.preventDefault();
            if (confirmMsg) {
                const confirm = createGenericModal({
                    bodyHtml: confirmMsg,
                    actions: [
                        {
                            title: 'No',
                            handler: 'dismiss',
                            fill: 'outline',
                            color: 'gray',
                        },
                        {
                            title: 'Yes',
                            handler: () => true,
                            handlerBehavior: 'dismiss',
                            fill: 'solid',
                        },
                    ],
                });
                confirm.show();
                const confirmation = await confirm.dismissed();
                if (!confirmation) {
                    return;
                }
            }
            el.classList.add('is--flushing');
            Object.assign(el.style, {
                pointerEvents: 'none',
                opacity: '0.5',
            });
            try {
                const msg = await callback();
                if (msg) {
                    createGenericModal({
                        bodyHtml: msg,
                    }).show();
                }
            }
            catch (err) {
                console.error(err);
                createGenericModal({
                    bodyHtml: failureMsg || '<p>Something went wrong</p><pre>' + JSON.stringify(err) + '</pre>',
                }).show();
            }
            el.classList.remove('is--flushing');
            Object.assign(el.style, {
                pointerEvents: '',
                opacity: '',
            });
        };
    }
}
